export default {
  orgProfileList: [],
  orgProfile: {},
  orgActiveFeatures: [],
};
